const adminRoutes = [
  {
    path: '/admin',
    component: () => import('@/layouts/AdminLayout.vue'), 
    children: [
      { path: '', redirect: 'home' }, // Redirect /admin to dashboard
      {
        path: 'home',
        name: 'Admin Dashboard',
        component: () => import('@/pages/admin/Dashboard.vue'),
        meta: { requiresAuth: true },
      },
      {
        path: 'users',
        name: 'Users List',
        component: () => import('@/pages/admin/user/UserListing.vue'),
        meta: { requiresAuth: true },
      },
      {
        path: 'user/add',
        name: 'Add User',
        component: () => import('@/pages/admin/user/AddUser.vue'),
        meta: { requiresAuth: true },
      },
      {
        path: 'user/edit/:id',
        name: 'Edit Users',
        component: () => import('@/pages/admin/user/EditUser.vue'),
        meta: { requiresAuth: true },
      },
      {
        path: 'blogs',
        name: 'Blogs List',
        component: () => import('@/pages/admin/blog/BlogsListing.vue'),
        meta: { requiresAuth: true },
      },
      {
        path: 'blogs/add',
        name: 'Add Blog',
        component: () => import('@/pages/admin/blog/AddBlog.vue'),
        meta: { requiresAuth: true },
      },
      {
        path: 'blog/edit/:slug',
        name: 'Edit Blog',
        component: () => import('@/pages/admin/blog/EditBlog.vue'),
        meta: { requiresAuth: true },
        props: true,
      },
      {
        path: 'resources',
        name: 'Medias List',
        component: () => import('@/pages/admin/media/ResourcesListing.vue'),
        meta: { requiresAuth: true },
      },
      {
        path: 'resources/add',
        name: 'Add Media',
        component: () => import('@/pages/admin/media/AddMedia.vue'),
        meta: { requiresAuth: true },
      },
      {
        path: 'media/edit/:id',
        name: 'Edit Media',
        component: () => import('@/pages/admin/media/EditMedia.vue'),
        meta: { requiresAuth: true },
      },
      {
        path: 'categories',
        name: 'Categories List',
        component: () => import('@/pages/admin/category/CategoryListing.vue'),
        meta: { requiresAuth: true },
      },
      {
        path: 'category/add',
        name: 'Add Category',
        component: () => import('@/pages/admin/category/AddCategory.vue'),
        meta: { requiresAuth: true },
      },
      {
        path: 'category/edit/:id',
        name: 'Edit Category',
        component: () => import('@/pages/admin/category/EditCategory.vue'),
        meta: { requiresAuth: true },
      },
      {
        path: 'notifications/add',
        name: 'Add Notification',
        component: () => import('@/pages/admin/notification/AddNotification.vue'),
        meta: { requiresAuth: true },
      },
      {
        path: 'notifications',
        name: 'Notifications List',
        component: () => import('@/pages/admin/notification/NotificationListing.vue'),
        meta: { requiresAuth: true },
      },
      {
        path: 'notification/report/:id',
        name: 'Notification Report',
        component: () => import('@/pages/admin/notification/NotificationReport.vue'),
        meta: { requiresAuth: true },
        props: true,
      },
      // {
      //   path: 'notification/edit/:id',
      //   name: 'Edit Notification',
      //   component: () => import('@/pages/admin/notification/EditNotification.vue'),
      //   meta: { requiresAuth: true },
      //   props: true,
      // },
    ],
  },
  {
    path: '/cms/login',
    name: 'Admin Login',
    component: () => import('@/pages/admin/Login.vue'),
    meta: { requiresAuth: false },
  },
];

export default adminRoutes;
